export default __webpack_public_path__ + "static/media/gallery-pipe.59e8dc3c.webp";